<ion-content>
  <app-global-page-header [title]="title | translate">
    <div slot="end">
      <ion-button
        color="medium"
        fill="clear"
        shape="round"
        (click)="dismissModal()"
      >
        <i class="fa-solid fa-times"></i>
      </ion-button>
    </div>
  </app-global-page-header>

  <div class="p-4">
    <div class="row">
      <div class="col-6">
        <div
          class="p-4 pointer-hover defualtBox"
          [class.select]="currentValue === firstChoice!.value"
          (click)="choiceValue(firstChoice!.value!)"
        >
          <div class="text-center fw-normal color-medium">
            {{ firstChoice?.title | translate }}
          </div>

          <div>
            <img
              style="width: 100%; object-fit: contain; height: 200px"
              [src]="firstChoice?.image"
            />
          </div>
        </div>
      </div>
      <div class="col-6">
        <div
          class="p-4 pointer-hover defualtBox"
          [class.select]="currentValue === secondChoice!.value"
          (click)="choiceValue(secondChoice!.value!)"
        >
          <div class="text-center fw-normal color-medium">
            {{ secondChoice?.title | translate }}
          </div>

          <div>
            <img
              style="width: 100%; object-fit: contain; height: 200px"
              [src]="secondChoice?.image"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</ion-content>

<ion-footer class="p-3">
  <div class="row">
    <div class="col text-center">
      <ion-button color="primary" (click)="continueModal()">
        {{ 'pages.invitation.continue' | translate }}
      </ion-button>
    </div>
  </div>
</ion-footer>
